import css from "./BreadCrumbs.module.scss";
import React, { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { catalogueItem } from "assets/types";
import {useSelector} from "react-redux";
import {RootState} from "store/store";

export const BreadCrumbs = () => {
  const catalogueItems = useSelector((state: RootState) => state.catalogue);
  const isMobile = useSelector((state: RootState) => state.mobile);

  const location = useLocation();
  const path = location.pathname;
  const pathArray = path.split("/");
  
  const linkSelector = (slug: string): ReactNode => {
    let link = "";
    let name = "";
    let existedItem = catalogueItems.find(
      (el: catalogueItem) => el.barcode === slug
    );

    switch (slug) {
      case "":
        link = "/";
        name = "Главная";
        break;
      case "catalogue":
        link = "/catalogue";
        name = "Косметика и гигиена";
        break;
      case "cart":
        link = "/cart";
        name = "Корзина";
        break;
      default:
        link = "/" + slug;
        name = existedItem
          ? existedItem.name
          : "Страница не найдена";
    }

    return (
      <Link
        className={
          slug === [...pathArray].pop()
            ? css.nav__link + " " + css.nav__link_active
            : css.nav__link
        }
        key={link}
        to={link}
      >
        {name}
      </Link>
    );
  };

  if (!isMobile) {
    return (
      <nav className={css.nav}>
        {[...new Set(pathArray)].map((element) => linkSelector(element))}
      </nav>
    );
  } else {
    return (
      <nav
        style={{ display: path !== "/" ? "flex" : "none" }}
        className={css.mobileNav}
      >
        <Link
          to={
            pathArray.length > 2 ? [...pathArray].slice(0, -1).join("/") : "/"
          }
          className={css.mobileNav__btn}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="8"
            viewBox="0 0 10 20"
            strokeWidth={2.5}
          >
            <polyline points="10,0 0,10 10,20" />
          </svg>
        </Link>
        <span className={css.mobileNav__text}>назад</span>
      </nav>
    );
  }
};
